/**
 * FIXME Reorganize these interfaces into appropriate directories, such as `../../src/Address/`
 */
import type { IPhoneNumber } from '@/Phone';

import type { IAddress } from '../../Address';
import type { CollectionSiteRole, ScopedRoleType } from '../types';

export enum PopulationRelationship {
  EMPLOYEE = 'employee',
  HEALTH_INSURANCE_BENEFICIARY = 'health_insurance_beneficiary',
  NON_HEALTH_INSURANCE_BENEFICIARY = 'non_health_insurance_beneficiary',
}

/**
 * This is an API interface, and multi-word properties are in lower_snake_case format.
 */
export interface ICollectionSitePermission {
  collection_site_id: number;

  collection_site_name: string;

  permission_type: CollectionSiteRole;
}

/**
 * This is an API interface, and multi-word properties are in lower_snake_case format.
 */
export interface IConsentMap {
  discovery: boolean | null;

  genetic_score_study: boolean | null;

  routing_authorization: boolean | null;
}

/**
 * This is an API interface, and multi-word properties are in lower_snake_case format.
 */
export interface ISimpleInstitution {
  id: number;
  name: string;

  fax_number: IPhoneNumber;
  address: IAddress;
}

/**
 * This is an API interface, and multi-word properties are in lower_snake_case format.
 */
export interface IDetailedProviderProfile {
  id: number;

  first_name: string;

  last_name: string;
  institution?: ISimpleInstitution;
}

/**
 * This is an API interface, and multi-word properties are in lower_snake_case format.
 */
export interface IScopedRole {
  role_type: ScopedRoleType;

  scope_name: string;

  scope_content_type: string;
}

/**
 * This is an API interface, and multi-word properties are in lower_snake_case format.
 */
export interface IPopulation {
  name: string;

  short_name?: string;

  organization_name?: string;
}

/**
 * This is an API interface, and multi-word properties are in lower_snake_case format.
 */
export interface IPopulationMembership {
  population: IPopulation;

  relationships: PopulationRelationship[];
}

/**
 * This is an API interface, and multi-word properties are in lower_snake_case format.
 */

export interface IPersonalIdentity {
  id?: number;
  person?: number;
  preferred_name: string;
  pronouns: string;
  gender_identity: string[];
  self_described_gender_identity: string[];
  sexual_orientation: string[];
  self_described_sexual_orientation: string[];
}
